import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-not-suitable-to-iframe',
  templateUrl: './not-suitable-to-iframe.component.html',
})
export class NotSuitableToIframeComponent implements OnInit {
  constructor(public route: ActivatedRoute) {}

  paymentUrl: any = '';
  ngOnInit() {
    this.paymentUrl = this.route.snapshot.queryParams['currLocation'];
  }
  redirectToPayment() {
    window.open(this.paymentUrl, '_blank');
  }
}
